const DEFAULTS = {
    MAP_RATIO:           0.54,
    DEFAULT_FILL:        '#d4d5d7',
    mapDataPath:         './vendor/map-data/mapData.js',
    mainWrapper:         '.b-interactive-map',
    mapArea:             '.b-interactive-map__map-area',
    filterWrapper:       '.b-interactive-map__filter',
    dataList:            '.b-interactive-map__data',
    geoObjectsContainer: '.i-map-geo-objects'
};

class InteractiveMap {
    constructor(settings) {

        this.settings        = {...DEFAULTS, ...settings};
        this.pointsSettings  = [];
        this.regionsSettings = {};
        this.filters         = {
            regions: null,
            points:  null
        };

        this.$mapArea = $(this.settings.mapArea);

        if (0 === this.$mapArea.length) {
            return;
        }


        this.$wrapper  = this.$mapArea.closest(this.settings.mainWrapper);
        this.$filter   = $(this.settings.filterWrapper, this.$wrapper);
        this.$dataList = $(this.settings.dataList, this.$wrapper);

        this.addMapData().then(() => {
            this.init();
        });
    }

    init() {
        this.setGEOData();
        this.createMap();
        this.addArea();
        this.addPoint();
        this._attachEvents();
        this._filterInit();
    }

    getMapOffsets() {
        const mapWidth  = this.$mapArea.width();
        const mapHeight = mapWidth * this.settings.MAP_RATIO;

        this.mapWidth  = mapWidth;
        this.mapHeight = mapHeight;

        return {
            mapWidth,
            mapHeight
        }
    }

    createMap() {
        this.getMapOffsets();

        const {
                  mapWidth,
                  mapHeight,
                  settings
              } = this;

        const scale = this.mapWidth / 1.4;

        const projection = d3.geoMercator()
            .rotate([-100, -61])
            .center([-5, 8])
            .scale(scale)
            .translate([mapWidth / 2, mapHeight / 2])
            .precision(.01);

        const path = d3.geoPath().projection(projection);

        const {mapArea} = settings;
        const svg       = d3.select(mapArea)
            .append('svg')
            .attr("preserveAspectRatio", "xMinYMin")
            .attr("width", mapWidth)
            .attr("height", mapHeight);

        this.regionGroup = svg.append("g")
            .attr("class", "region-group").selectAll('path');

        window.addEventListener('resize', () => {
            this._resize();
        });

        this.areaTooltip = d3.select('body')
            .append('div')
            .attr('class', 'region-tooltip');

        this.pointTooltip = d3.select('body')
            .append('div')
            .attr('class', 'point-tooltip');

        this.projection = projection;
        this.path       = path;
        this.svg        = svg;
    }

    /**
     * Добавление данных для построения карты
     * @returns {Promise<unknown>|Promise<{transform: {scale: number[], translate: number[]}, bbox: number[], objects: {name: {geometries: ({type: string, arcs: [number[]], properties: {XY: number[], ISO: string, CITY: string, RID: string, FD: string, NAME: string}}|{type: string, arcs: number[][][], properties: {XY: number[], ISO: string, CITY: string, RID: string, FD: string, NAME: string}}|{type: string, arcs: number[][], properties: {XY: number[], ISO: string, CITY: string, RID: string, FD: string, NAME: string}}|{type: string, arcs: number[][][], properties: {XY: number[], ISO: string, CITY: string, RID: string, FD: string, NAME: string}}|{type: string, arcs: [[[number]], [number[]]], properties: {XY: number[], ISO: string, CITY: string, RID: string, FD: string, NAME: string}})[], type: string}}, type: string, arcs: number[][][]}>}
     */
    addMapData() {

        if (InteractiveMap.instansePromise) {
            return InteractiveMap.instansePromise;
        }

        if (undefined !== InteractiveMap.mapData) {
            return Promise.resolve(InteractiveMap.mapData);
        }

        InteractiveMap.instansePromise = new Promise((res, rej) => {
            try {
                $.getScript(this.settings.mapDataPath)
                    .done(() => {

                        InteractiveMap.mapData = window.RUSSIA_REGIONS_GEO;
                        res(window.RUSSIA_REGIONS_GEO);
                    });
            } catch (e) {
                rej();
            }
        });

        return InteractiveMap.instansePromise;
    }

    addArea() {
        const {path, regionGroup} = this;

        console.log(InteractiveMap.mapData)

        this.rPath = regionGroup
            .data(InteractiveMap.mapData.features)
            .enter().append("path")
            .attr("d", path)
            .attr('class', (d) => {
                let classList = 'region';
                if (this.regionsSettings[d.properties.ISO] !== undefined) {
                    classList += ' is-interactive'
                }
                return classList;
            })
            .attr("title", function(d) {
                return d.properties.NAME;
            })
            .attr("data-region", function(d) {
                return d.properties.ISO;
            })
            .style("fill", (d) => {
                return this._getRegionColor(d);
            })
            .style("stroke", '#ffffff');
    }

    addPoint() {
        /*добавление точек*/
        const {mapWidth, pointsSettings, svg, projection} = this;

        svg.selectAll("g.map-point")
            .remove();
        this.points = svg.selectAll("g.map-point")
            .data([...pointsSettings])
            .enter()
            .append("g")
            .attr("class", "map-point")
            .attr("transform", function(d) {
                return "translate(" + projection([d.lon, d.lat]) + ")";
            });

        const pointSize = mapWidth < 768 ? 12 : 24;

        this.points
            .append("use")
            .attr('class', 'point-img')
            .attr("href", "#i-map-point")
            .attr("width", pointSize)
            .attr("height", pointSize)
            .attr("transform", `translate( 0, -${pointSize})`)
            .style("fill", function(d) {
                return d.color;
            });
    }

    setGEOData() {
        $('[data-map-type]', this.$dataList).each((i, item) => {
            const type = item.dataset.mapType;

            if (type === 'point') {
                const {color, title, lat, lon} = item.dataset;
                this.pointsSettings.push({
                    color,
                    title,
                    tooltip: item.textContent.length > 2 ? item.innerHTML : undefined,
                    lat,
                    lon
                });

            } else if (type === 'region') {
                const {color, title, iso} = item.dataset;
                this.regionsSettings[iso] = {
                    color,
                    title,
                    tooltip: item.textContent.length > 2 ? item.innerHTML : undefined
                };
            }
        });
    }

    updateData() {
        this.regionsSettings = {};
        this.pointsSettings  = [];
        this.setGEOData();

        this.rPath.attr("d", this.path)
            .attr('class', (d) => {
                let classList = 'region';
                if (this.regionsSettings[d.properties.ISO] !== undefined) {
                    classList += ' is-interactive'
                }
                return classList;
            })
            .attr("title", function(d) {
                return d.properties.NAME;
            })
            .attr("data-region", function(d) {
                return d.properties.ISO;
            })
            .style("fill", (d) => {
                return this._getRegionColor(d);
            })
            .style("stroke", '#ffffff');

        this.addPoint();
        this._attachEvents();
    }

    _filterAreas() {
        this.rPath.style('fill', (d) => this._getRegionColor(d))
    };

    _filterPoint() {
        this.svg.selectAll(".map-point").style('opacity', (d) => this._getPointOpacity(d))
    }

    _getRegionColor(region) {
        const {ISO}                                = region.properties;
        const {settings, regionsSettings, filters} = this;
        const {DEFAULT_FILL}                       = settings;

        if (!regionsSettings[ISO]) return DEFAULT_FILL;

        const {color} = regionsSettings[ISO];

        region.disable = false;

        if (filters.regions !== null &&
            filters.regions !== color
        ) {
            region.disable = true;
            return DEFAULT_FILL;
        }

        if (color) {
            return color;
        }

        return DEFAULT_FILL;
    }

    _getPointOpacity(point) {
        const {filters} = this;

        const {color} = point;
        if (filters.points !== null && filters.points !== color) {
            return 0
        }
        return 1;
    }

    _resize() {
        this.getMapOffsets();

        const {
                  mapWidth,
                  mapHeight,
                  projection,
                  svg,
                  path
              } = this;

        const scale = mapWidth / 1.4;
        projection
            .scale(scale)
            .translate([mapWidth / 2, mapHeight / 2])
            .precision(0.1);
        svg.attr('width', mapWidth);
        svg.attr('height', mapHeight);

        // resize the map
        svg.selectAll('.region').attr('d', path);
        svg.selectAll(".map-point").attr("transform", function(d) {
            return "translate(" + projection([d.lon, d.lat]) + ")";
        });
    }

    _attachEvents() {
        const {rPath, areaTooltip, _getRegionColor, pointTooltip, points} = this;
        const self                                                        = this;

        rPath.on('mouseover', pathOver)
            .on('mouseleave', pathLeave);

        points.on('click', pointClick);
        rPath.on('click', areaClick);

        function pathOver(d) {

            const {ISO}      = d.properties;
            const regionData = self.regionsSettings[ISO];
            const element    = document.querySelector(`.landing-block-card-place[data-iso="${ISO}"]`)
            if (!regionData || d.disable) {
                return;
            }

            let hoverLabel = (regionData && regionData.title !== undefined) ? regionData.title : d.properties.NAME
            if (element) {
                hoverLabel =element.querySelector('.landing-block-node-place-title').textContent
            }

            if (ISO) {
                areaTooltip.text(hoverLabel);
                areaTooltip
                    .style("left", (d3.event.pageX) + "px")
                    .style("top", (d3.event.pageY - 30) + "px")
                    .transition().duration(300)
                    .style('opacity', 1);
            }
            d3.select(this).style('fill', '#182128')
        }

        function pathLeave() {
            d3.select(this).style('fill', d => _getRegionColor.call(self, d));
            areaTooltip
                .transition().duration(300)
                .style("opacity", 0);
        }

        function pointClick(d) {

            const {tooltip} = d;

            if (tooltip) {
                pointTooltip.html(tooltip);
                pointTooltip
                    .style("display", 'block')
                    .style("left", (d3.event.pageX + 10) + "px")
                    .style("top", (d3.event.pageY - 30) + "px")
                    .transition().duration(300)
                    .style('opacity', 1);
            }
        }

        function areaClick(d) {
            const {ISO}       = d.properties;
            const regionData  = self.regionsSettings[ISO];
            const element     = document.querySelector(`.landing-block-card-place[data-iso="${ISO}"]`)
            const clickAction = element?.dataset?.clickAction
            const clickUrl    = element?.dataset?.href

            if (!regionData || d.disable || !regionData.tooltip || clickAction === 'none') {
                return;
            }

            if (clickAction === 'visit-url') {
                window.location.href = clickUrl
                return
            }
            if (regionData.tooltip) {
                pointTooltip.html(regionData.tooltip);
                pointTooltip
                    .style("display", 'block')
                    .style("left", (d3.event.pageX + 10) + "px")
                    .style("top", (d3.event.pageY - 30) + "px")
                    .transition().duration(300)
                    .style('opacity', 1);
            }
        }

        this.pointTooltip.on('mouseleave', () => {
            pointTooltip
                .transition().duration(300)
                .style('opacity', 0)
                .transition().delay(500)
                .style("display", 'none');

        });

        $(document).on('click', (e) => {

            if (!e.target.closest('.point-tooltip, .map-point, .region')) {
                pointTooltip
                    .transition().duration(300)
                    .style('opacity', 0)
                    .transition().delay(500)
                    .style("display", 'none');
            }
        });
    }

    _filterInit() {
        const {filters, $filter} = this;
        const self               = this;

        if (0 === $filter.length) {
            return;
        }

        $($filter).on('click', '[data-filter]', function(e) {
            e.preventDefault();
            const $el   = $(this);
            const value = $el.data('filter-value');
            const type  = $el.data('filter');

            $el.toggleClass('is-active').removeClass('is-disabled');

            if ($el.hasClass('is-active')) {
                $el.siblings(`[data-filter="${type}"]`).addClass('is-disabled').removeClass('is-active');
                filters[type] = value;
            } else {
                $el.siblings(`[data-filter="${type}"]`).removeClass('is-disabled');
                filters[type] = null;
            }

            self._filterAreas();
            self._filterPoint();
        });
	}
}
